import React from 'react';

const EnterpriseIcon = (props: React.SVGProps<SVGSVGElement>): JSX.Element => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}>
    <path
      d="M14 8V4H5V20H19V9H16V13.62C16 14.464 15.554 15.253 14.813 15.721L12 17.498L9.187 15.72C8.446 15.253 8 14.464 8 13.62V8H14ZM21 8V20.993C21.0009 21.1243 20.976 21.2545 20.9266 21.3762C20.8772 21.4979 20.8043 21.6087 20.7121 21.7022C20.6199 21.7957 20.5101 21.8701 20.3892 21.9212C20.2682 21.9723 20.1383 21.9991 20.007 22H3.993C3.72981 22 3.47739 21.8955 3.2912 21.7095C3.105 21.5235 3.00027 21.2712 3 21.008V2.992C3 2.455 3.449 2 4.002 2H14.997L21 8ZM10 13.62C10 13.77 10.087 13.924 10.255 14.03L12 15.132L13.745 14.03C13.913 13.924 14 13.77 14 13.62V10H10V13.62Z"
      fill="currentColor"
    />
  </svg>
);

export default EnterpriseIcon;
